import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";

const Chart1 = ({ data }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />

                <YAxis />
                <Tooltip />
                <Legend />

                <Bar dataKey="등록건수" stackId="a" fill="#8884d8">
                    <LabelList dataKey="등록건수" position="inside" fill="white" fontSize={14} /> {/* 항상 표시 */}
                </Bar>
                <Bar dataKey="완료건수" stackId="a" fill="#82ca9d">
                    <LabelList dataKey="완료건수" position="inside" fill="white" fontSize={14} /> {/* 항상 표시 */}
                </Bar>
            </BarChart>
        </ResponsiveContainer>

    );
};

export default Chart1;
